import { FaUserCircle } from "react-icons/fa";
import PropTypes from 'prop-types';
import { Navlinks } from "./Navbar";
import { getUser } from "../Utility/getUser"; // Import the getUser function
import { useState, useEffect } from "react";

const ResponsiveMenu = ({ showMenu }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const loggedInUser = getUser();
    setUser(loggedInUser);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('user');
    setUser(null);
    window.location.href = '/signin';
  };

  return (
    <div
      className={`${
        showMenu ? "left-0" : "-left-[100%]"
      } fixed bottom-0 top-0 z-20 flex h-screen w-[75%] flex-col justify-between bg-white dark:bg-black dark:text-white px-8 pb-6 pt-16 text-black transition-all duration-200 md:hidden rounded-r-xl shadow-md`}
    >
      <div className="card">
        <div className="flex items-center justify-start gap-3">
          <FaUserCircle
            size={50}
            className="cursor-pointer"
            onClick={() => {
              if (user) {
                window.location.href = '/profile';
              }
            }}
          />
          <div>
            {user ? (
              <>
                <h1>Hello, {user.users_name}</h1>
                <h1 className="text-sm text-slate-500">Premium Benutzer</h1>
              </>
            ) : (
              <>
                 <a
                    href="/signin"
                    className="text-lg font-medium hover:text-red-500 py-2 transition-colors duration-500"
                  >
                    Login
                  </a>
              </>
            )}
          </div>
        </div>
        <nav className="mt-12 ">
          <ul className="space-y-4 text-xl">
            {Navlinks.map(({ id, name, link }) => (
              <li key={id}>
                <a href={link} className="mb-5 inline-block">
                  {name}
                </a>
              </li>
            ))}
            {user && (
              <>
                <li>
                  <a href="/dashboard" className="mb-5 inline-block">
                    Dashboard
                  </a>
                </li>
                <li>
                  <a href="/myfavorite" className="mb-5 inline-block">
                    MyFavorite
                  </a>
                </li>
                <li>
                  <button
                    onClick={handleLogout}
                    className="mb-5 inline-block text-left w-full"
                  >
                    Logout
                  </button>
                </li>
              </>
            )}
          </ul>
        </nav>
      </div>
      <div className="footer">
        <h1>
          developed by <a href="https://masit.net"><span className="text-red-500 text-l font-serif">MASIT</span></a>
        </h1>
      </div>
    </div>
  );
};

ResponsiveMenu.propTypes = {
  showMenu: PropTypes.bool.isRequired,
};

export default ResponsiveMenu;
